<template>
  <div>
    <v-card flat>
        <v-card-title class="headline">
            Edit Service
        </v-card-title>

        <div class="d-flex flex-row flex-wrap">
            <v-text-field
                v-model.trim="service.name"
                label="Service Name (required)"
                validate-on-blur
                full-width
                :rules="[...inputRulesName, uniqueNameRule]"
                style="max-width: 300px"
                color="ppc_darkgreen"
                background-color="white"
                class="rounded-xl"
                outlined
                :disabled="$store.getters.loadingApp === 1"
            />

            <v-switch
                v-model="service.active"
                label="Active"
                class="mx-5"
                :disabled="$store.getters.loadingApp === 1"
            />

            <v-switch
                v-model="service.packageMaker"
                label="PackageMaker"
                class="mx-5"
                :disabled="service.agency > 0 || $store.getters.loadingApp === 1"
            />

            <v-switch
                v-model="service.website"
                label="Website"
                class="mx-5"
                :disabled="service.agency > 0 || $store.getters.loadingApp === 1"
            />

            <div style="width: 200px">
                <v-select
                v-model="service.agency"
                :items="$store.state.available_agencies"
                item-text="name"
                item-value="id"
                :menu-props="{ auto: true }"
                label="No specific agency"
                single-line
                prepend-icon="fab fa-sourcetree ppc_darkgreen--text"
                validate-on-blur
                clearable
                :disabled="$store.getters.loadingApp === 1"
                />
            </div>
        </div>
    </v-card>

    <v-card
    class="rounded-xl pa-4 mx-2 my-2"
    width="300px"
    >
    <v-select
        v-model="service.type_id"
        :items="typeSelect"
        :prepend-icon="service.icon"
        label="Service Type (required)"
        :rules="inputRulesReq"
        :disabled="$store.getters.loadingApp === 1"
        @change="changeTypeIcon($event)"
    />
    </v-card>

    <v-card
        class="rounded-xl my-5 mx-2"
        max-width="1150px"
        >
        <v-text-field
            v-model.trim="service.info_link"
            label="Info URL"
            validate-on-blur
            full-width
            color="ppc_darkgreen"
            class="px-5"
            prepend-icon="mdi-web"
            clearable
            :disabled="$store.getters.loadingApp === 1"
        />
    </v-card>
  </div>
</template>

<script>
import inputRules from '@/mixins/inputRules'

export default {
  name: 'ServiceGeneral',

  mixins: [inputRules],

    props: {
        service: {
            type: Object,
            required: true
        },

        services: {
            type: Array,
            default: () => []
        },

        typeSelect: {
            type: Array,
            required: true
        },
    },

  methods: {

    uniqueNameRule(value) {
        if (!value) return true

        const duplicate = this.services.some(item =>
            item.name?.trim().toLowerCase() === value.trim().toLowerCase() &&
            item.service_number !== this.service.service_number &&
            (
            item.agency === this.service.agency ||
            (item.agency == null && this.service.agency == null)
            )
        )

        return !duplicate || 'A service with this name already exists'
    },

    changeTypeIcon(event) {
      this.$emit('change-type-icon', event)
    }
    
  }
  
}
</script>